import { toast } from "react-toastify";
import { call, delay, put, takeLatest } from "redux-saga/effects";
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import { setPostApiStatus } from "../../../actions/apiStatusActions";
import { DepartmentPermissionActionTypes, DepartmentPermissionActions } from "../../../actionTypes/permissions/departmentPermissionTypes";
import { setDepartmentPermissionList, setDepartmentPermissionListCount } from "../../../actions/permissions/departmentPermission";
import { addDepartmentPermissionApi, getDepartmentPermissionListApi } from "../../requests/permissions/departmentPermission";





function* getDepartmentPermssionListHandler(action: DepartmentPermissionActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getDepartmentPermissionListApi, action.payload);
    if (data.status) {
      yield put(setDepartmentPermissionList(data?.data?.rows));
      yield put(setDepartmentPermissionListCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}


function* addDepartmentPermissionHandler(action: DepartmentPermissionActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(addDepartmentPermissionApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}



// Permission sagas
export default function* departmentPermissionSaga() {
  yield takeLatest(DepartmentPermissionActions.GET_DEPARTMENT_PERMISSION_LIST, getDepartmentPermssionListHandler);
  yield takeLatest(DepartmentPermissionActions.ADD_DEPARTMENT_PERMISSION, addDepartmentPermissionHandler);
}
